/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import resume from "../Resume/Suraj-Kamat-Resume.pdf";
import homeGif from "../Image/home_anime.f372ef86.gif";

export const Home = () => {

    const handleResume = () => {
        window.open("https://drive.google.com/file/d/1fCow8sfk-xgyl8HhRI0tXiwCVz3AAeMO/view?usp=sharing",
            "_blank")
    }

    return (<>
        <section id="home">
            <div className="home-text">
                <span>Hello, I'm</span>
                <h1 id="user-detail-name">Suraj Kamat</h1>
                <h2>Full Stack Web Developer</h2>
                <br />
                {/* <a id="resume-link-2" href={resume} download="Suraj_Kamat_Resume" target="_blank"><button className='resume-button' id="resume-button-2">Resume</button></a> */}


                <a onClick={handleResume} id="resume-link-2" href={resume} download="Suraj_Kamat_Resume" target="_blank">
                    <button className="resume-button" id="resume-button-2">Resume</button></a>



            </div>
            <div className="home-img1">
                <img
                    src={homeGif}
                    alt="" className="homeGif" />
            </div>

        </section>
    </>
    )
}
